import React from 'react';
import { Link } from 'react-router-dom';

export default function ClaretCompanyToolEmbed({ menu, title, children }) {
  return (
    <div className="pc-page">
      <div className="pc-crumb">
        <Link to="/procore">Portfolio</Link>
        {' / '}
        <Link to="/procore/settings">Settings</Link>
        {' / '}
        {menu}
        {' / '}
        {title}
      </div>
      <div className="pc-title-row">
        <h1>{title}</h1>
      </div>
      <div className="pc-je-embed pc-tool-embed">{children}</div>
    </div>
  );
}
